export const CATEGORY_ICON_MAP = {
  biografias: 'portrait',
  biologia: 'frog',
  'conhecimento-geral': 'dice',
  filosofia: 'feather',
  fisica: 'atom-alt',
  geografia: 'globe-americas',
  'historia-geral': 'hourglass-half',
  'historia-brasil': 'book',
  ingles: 'comment-alt',
  literatura: 'book-open',
  matematica: 'calculator',
  portugues: 'font',
  quimica: 'flask',
  redacao: 'file-alt',
  sociologia: 'users',
  atualidades: 'newspaper',
}
